import { STORE_FOOD_COURT_SETTINGS } from '../actions';

export default function foodCourtSettings(state = {}, action) {
    switch (action.type) {
      case STORE_FOOD_COURT_SETTINGS:
        return action.payload;
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/reducers/foodCourtSettings.js